
<div class="ws-phone-input ws-field">
  <ws-input
    ref="input"
    v-bind="$attrs"
    v-model="phoneNumber"
    :error="hasMessage"
    hide-bottom-space
    autocomplete="tel-national"
    :restrict="restrict"
    v-on="omit({...$listeners}, 'input')"
  >
    <!-- @blur="hideTooltip" -->
    <template v-slot:prepend>
      <ws-select
        v-if="prefix"
        ref="select"
        v-model="prefix"
        :multiple="false"
        :dark="$attrs['dark'] || false"
        class="ws-phone-prefix-select"
        popup-content-class="ws-phone-prefix-select-content"
        :options="optionsOrdered"
        option-value="code"
        option-label="id"
        option-description="description"
        transition-show="jump-down"
        transition-hide="jump-up"
        hide-bottom-space
        autocomplete="tel-country-code"
        tabindex="0"
      >
        <template v-slot:selected-item="scope">
          <ws-country-flag
            :key="prefix.id"
            :country="prefix.id"
            class="q-mr-sm"
          />
          {{ scope.opt.code }}
        </template>
        <template v-slot:option="scope">
          <q-separator v-if="scope.index === numOfSuggested" />
          <q-item
            v-bind="scope.itemProps"
            v-on="scope.itemEvents"
          >
            <q-item-section avatar>
              <ws-country-flag :key="scope.opt.id" :country="scope.opt.id" />
            </q-item-section>
            <q-item-section>
              <q-item-label>{{ scope.opt.code }}</q-item-label>
              <q-item-label>{{ scope.opt.country }}</q-item-label>
            </q-item-section>
          </q-item>
        </template>
      </ws-select>
    </template>

    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </ws-input>
</div>
